import { ModelKey } from "../types/offers"

export default (model: string) => {
  switch (model) {
    case "Taos":
    case "taos":
      return ModelKey.TAOS;
    case "Golf GTI":
    case "golf gti":
      return ModelKey.GOLFGTI;
    case "Golf R":
    case "golf r":
      return ModelKey.GOLFR;
    case "Tiguan":
    case "tiguan":
      return ModelKey.TIGUAN;
    case "Atlas":
    case "atlas":
      return ModelKey.ATLAS;
    case "Atlas Cross Sport":
    case "atlas cross sport":
    case "Cross Sport":
    case "cross sport":
      return ModelKey.CROSSSPORT;
    case "Jetta":
    case "jetta":
      return ModelKey.JETTA;
    case "Jetta GLI":
    case "jetta gli":
      return ModelKey.JETTAGLI;
    case "ID.4":
    case "id.4":
    case "ID4":
    case "id4":
      return ModelKey.ID4;
    case "ID. Buzz":
    case "id. buzz":
    case "IDBUZZ":
    case "idbuzz":
      return ModelKey.IDBUZZ;
    default:
      return undefined;
  }
}
